import global from "./global";

/* eslint-disable no-restricted-globals */
var isWindowAwailable = typeof window !== "undefined";

/* eslint-enable no-restricted-globals */

const nav = typeof navigator !== "undefined" ? navigator : {userAgent:""};

export default {
	isIE: isWindowAwailable && (nav.userAgent.indexOf("MSIE") >= 0 || nav.userAgent.indexOf("Trident") >= 0),
	isOpera: isWindowAwailable && (nav.userAgent.indexOf("Opera") >= 0 || nav.userAgent.indexOf("OPR") >= 0),
	isChrome: isWindowAwailable && (nav.userAgent.indexOf("Chrome") >= 0),
	isSafari: isWindowAwailable && (nav.userAgent.indexOf("Safari") >= 0 || nav.userAgent.indexOf("Konqueror") >= 0),
	isFF: isWindowAwailable && (nav.userAgent.indexOf("Firefox") >= 0),
	isIPad: isWindowAwailable && (nav.userAgent.search(/iPad/gi) >= 0),
	isEdge: isWindowAwailable && (nav.userAgent.indexOf("Edge")!=-1),
	isNode: (!isWindowAwailable || typeof navigator == "undefined" || (typeof PRODUCTION !== "undefined" && PRODUCTION === "test")),
	isSalesforce: isWindowAwailable && (!!global["Sfdc"] || !!global["$A"] || global["Aura"])
};
